function afterCreation() {
  $(".autocomplete-tab-buttons button").on("click", function () {
    $(".autocomplete-tab-buttons button").removeClass("active");
    $(this).addClass("active");
    $(".autocomplete-tab").attr("hidden", true);
    $("#" + $(this).attr("data-tab")).removeAttr("hidden");
  });
}

document.addEventListener("algolia.hooks.initialize", function () {
  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteOptions",
    function (options) {
      options.placeholder = "Search";
      return options;
    }
  );

  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteMainTemplate",
    function (_defaultTemplate, templateOptions, elements, displaySuggestions) {
      const { html } = templateOptions;

      return html`
      <div class="autocomplete-results" id="autocomplete-results">
        <div class="autocomplete-tab-buttons">
          <button type="button" id="search-products-button" class="active" data-tab="search-products">Products</button>
          <button type="button" id="search-collections-button" data-tab="search-collections">Collections</button>
        </div>
        <div class="autocomplete-tabs">
          <div class="autocomplete-tab" id="search-products">
            ${elements.products}   
          </div>
          <div class="autocomplete-tab" id="search-collections" hidden>
            ${elements.collections} 
          </div>
        </div>
        <script type="text/javascript">afterCreation();</script>
      </div>`;
    }
  );

  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteMainProductsTemplate",
    function (_defaultTemplate, templateOptions, elements) {
      const { html } = templateOptions;
      return html`
      <div class="autocomplete-results" id="autocomplete-results">
        <div class="autocomplete-tabs">
          <div class="autocomplete-tab" id="search-products">
            ${elements.products}   
          </div>
        </div>
      </div>`;
    }
  );

  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteHeaderTemplate",
    function (_defaultTemplate, templateOptions, resource) {
      const { html } = templateOptions;
      return html``;
    }
  );

  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteFooterTemplate",
    function (_defaultTemplate, templateOptions) {
      const { html, state } = templateOptions;
      return html`
      <div class="aa-footer">
        <a
          class="predictive-search__view-all link w-full text-start focus-inset has-ltr-icon js-search-link"
          href="${window.Shopify.routes.root}search?q=${state.query}"
        >
          View All Search Results
          <svg width="24" height="24" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5" fill="none" aria-hidden="true" focusable="false" role="presentation" class="icon"><path d="M4.696 12h14.686m-7.007-7.5 7.5 7.5-7.5 7.5"></path></svg>
        </a>
      </div>
    `;
    }
  );

  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteProductTemplate",
    function (
      _defaultTemplate,
      templateOptions,
      distinct,
      itemLink,
      trackSearchAttribution
    ) {
      const { html, item, components } = templateOptions;

      var freeShipping =
        item.hasOwnProperty("meta") &&
        item.meta.hasOwnProperty("custom") &&
        item.meta.custom.hasOwnProperty("is_free_shipping") &&
        item.meta.custom.is_free_shipping == "true";

      return html`
      <a href="${itemLink}" onClick="${() => trackSearchAttribution(item)}">
        <div class="item-media">
          ${
            item.image
              ? html`<img
              src="${algoliaShopify.helpers.renderImage(item, 125).src}"
              srcset="${algoliaShopify.helpers.renderImage(item, 125).srcset}"
              sizes="${algoliaShopify.helpers.renderImage(item, 125).sizes}"
              alt="${item.title}" />`
              : html`<img
              src="https://monstorscooterparts.shop/cdn/shop/files/placeholder.png"
              alt="${item.title}" />`
          }
        </div>
        <div class="item-info">
          <h3 class="item-title h6">${components.Highlight({
            hit: item,
            attribute: "title",
          })}</h3>
          <div class="item-price">
            <div class="price__default">
              <strong class="price__current">${algoliaShopify.helpers.displayPrice(
                item,
                distinct
              )}</strong>
              <s class="price__was">
                ${algoliaShopify.helpers.displayStrikedPrice(
                  item.price,
                  item.compare_at_price
                )}
              </s>
              ${
                freeShipping &&
                html`<span class="price-free-shipping">Free Shipping</span>`
              }
            </div>
          </div>
          <div class="item-vendor">
          ${
            item.vendor &&
            components.Highlight({ attribute: "vendor", hit: item })
          }
          </div>
        </div>
      </a>`;
    }
  );

  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteCollectionsTemplate",
    function (_defaultTemplate, templateOptions, itemLink) {
      const { html, item, components } = templateOptions;
      return html`
      <a href="${itemLink}">
        <div class="item-media">
          ${
            item.image
              ? html`<img
              src="${algoliaShopify.helpers.renderImage(item, 125).src}"
              srcset="${algoliaShopify.helpers.renderImage(item, 125).srcset}"
              sizes="${algoliaShopify.helpers.renderImage(item, 125).sizes}"
              alt="${item.title}" />`
              : html`<img
              src="https://monstorscooterparts.shop/cdn/shop/files/placeholder.png"
              alt="${item.title}" />`
          }
        </div>
        <div class="item-info">
          <h3 class="item-title h6">${components.Highlight({
            hit: item,
            attribute: "title",
          })}</h3>
        </div>
      </a>`;
    }
  );

  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteNoResultsTemplate",
    function (_defaultTemplate, templateOptions) {
      const { html, state } = templateOptions;

      return html`
      <div class="autocomplete-results" id="autocomplete-results">
        <div class="autocomplete-tabs">
          <div class="autocomplete-tab" id="no-results">
            ${algoliaShopify.translation_helpers.no_result_for(state.query)} 
          </div>
        </div>
      </div>`;
    }
  );
});
